import CustomerServiceFaq from './CustomerServiceFaq'

export default CustomerServiceFaq
